import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, Printer, ArrowLeft } from "lucide-react";
import api, { errMsg, LOGO_URL } from "@/lib/api";
import { toast } from "sonner";

const PrintAddresses = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const start = params.get("start");
  const end = params.get("end") || start;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/daily-summary", { params: { start, end } })
      .then((r) => { setData(r.data); setLoading(false); })
      .catch((e) => { toast.error(errMsg(e)); setLoading(false); });
  }, [start, end]);

  const dateLabel = start === end ? start : `${start} to ${end}`;

  if (loading) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin text-goldsoft" size={40} /></div>;

  return (
    <div className="min-h-screen bg-white text-black">
      <div className="print:hidden sticky top-0 bg-choco text-cream px-5 py-3 flex items-center justify-between">
        <button data-testid="print-back" onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-sm hover:text-goldsoft"><ArrowLeft size={16} /> Back</button>
        <button data-testid="print-btn" onClick={() => window.print()} className="inline-flex items-center gap-2 rounded-full bg-gold text-chocodark font-semibold px-5 py-2 text-sm hover:bg-goldsoft"><Printer size={16} /> Print</button>
      </div>

      <div data-testid="print-page" className="mx-auto max-w-3xl px-6 py-8">
        <div className="flex items-center gap-4 border-b-2 border-black pb-4 mb-2">
          <img src={LOGO_URL} alt="" className="h-14 w-14 rounded-full object-cover" />
          <div>
            <h1 className="text-2xl font-bold">Nel Bake House – Delivery Addresses</h1>
            <p data-testid="print-date" className="text-sm mt-1">Date: {dateLabel} · {data?.orders.length || 0} confirmed orders</p>
          </div>
        </div>

        {(!data || data.orders.length === 0) ? (
          <p data-testid="print-empty" className="text-center py-16 text-sm">No confirmed orders for this date.</p>
        ) : (
          <div className="space-y-6 mt-6">
            {data.orders.map((o) => (
              <div key={o.order_id} data-testid={`print-order-${o.order_id}`} className="border-2 border-black rounded-lg p-5 break-inside-avoid">
                <p className="text-lg font-bold">Customer: {o.full_name}</p>
                <p className="mt-1 font-semibold">Phone: {o.phone}</p>
                <p className="mt-1 leading-relaxed">Address: {o.address}, {o.city}, {o.state} – {o.pincode}</p>
                <p className="mt-3 font-bold">Products:</p>
                <ul className="mt-1 space-y-0.5">
                  {(o.items || []).map((it, idx) => (
                    <li key={idx} className="leading-relaxed">• {it.name} × {it.quantity}</li>
                  ))}
                </ul>
                <p className="mt-3 text-sm font-semibold">Order No: {o.order_id}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PrintAddresses;
